module.exports = __webpack_public_path__ + "static/media/default-news.577f1394.jpg";